import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from 'app-modules/core/core.module';
import { FormsModule } from '@angular/forms'; 
import { CalibrationStatementsComponent } from './components/calibration-statements/calibration-statements.component';
import { CalibrationStatementsService } from './services/calibration-statements.service';



@NgModule({
  declarations: [
  ],
  imports: [
  ],
  providers: [
  ]
})
export class CalibrationStatementsModule { }
